import emptySplitApi from "../utils/rtk";
import { User, updateProfile } from "../types/User";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  data: any;
  status: number;
  message: string;
};

type GetCategoryBody = {
  start: number;
  length: number;
  search: string;
  category?: string;
};

type AddCategory = {
  category_image: number;
  category_name_en: string;
  category_name_ar: string;
  category_name_rs: string;
};

type AddSubCategoryBody = {
  category: number;
  sub_category_name_en: string;
  sub_category_name_ar: string;
  sub_category_name_rs: string;
  sub_category_image: number;
};

type UpdateSubCategoryBody = {
  body: {
    category: number;
    sub_category_name_en: string;
    sub_category_name_ar: string;
    sub_category_name_rs: string;
    sub_category_image: number;
  };
  id: string | undefined;
};

type UpdateCategoryParams = {
  id: string | undefined;
  body: {
    category_image: number;
    category_name_en: string;
    category_name_ar: string;
    category_name_rs: string;
  };
};

export const mainApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategory: builder.mutation<CommonResponseType, GetCategoryBody>({
      query: (body) => ({
        url: END_POINTS.category,
        method: "POST",
        body,
      }),
    }),
    addCategory: builder.mutation<CommonResponseType, AddCategory>({
      query: (body) => ({
        url: END_POINTS.addCategory,
        method: "POST",
        body,
      }),
    }),

    getCategoryById: builder.query<
      CommonResponseType,
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.categoryById}${id}/`,
        method: "GET",
      }),
    }),

    updateCategory: builder.mutation<CommonResponseType, UpdateCategoryParams>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateCategory}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteCategory: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteCategory}${id}/`,
        method: "DELETE",
      }),
    }),

    getSubCategory: builder.mutation<CommonResponseType, GetCategoryBody>({
      query: (body) => ({
        url: END_POINTS.subCategory,
        method: "POST",
        body,
      }),
    }),

    addSubCategory: builder.mutation<CommonResponseType, AddSubCategoryBody>({
      query: (body) => ({
        url: END_POINTS.addSubCategory,
        method: "POST",
        body,
      }),
    }),

    updateSubCategory: builder.mutation<
      CommonResponseType,
      UpdateSubCategoryBody
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateSubCategory}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    getSubCategoryById: builder.query<
      CommonResponseType,
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.subCategoryById}${id}/`,
        method: "GET",
      }),
    }),

    deleteSubCategory: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteSubCategory}${id}/`,
        method: "DELETE",
      }),
    }),

    allCategory: builder.query<CommonResponseType, {}>({
      query: ({ }) => ({
        url: `${END_POINTS.allCategory}`,
        method: "GET",
      }),
    }),
    allSubcategories: builder.query<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.allSubcategoriesByCatId}${id}/`,
        method: "GET",
      }),
    }),

    getChatList: builder.query<CommonResponseType, {}>({
      query: ({ }) => ({
        url: `${END_POINTS.chatList}`,
        method: "GET",
      }),
    }),
    getChatHistory: builder.query<CommonResponseType, { session: any }>({
      query: (session) => ({
        url: `${END_POINTS.chatHistory}${session}/`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetCategoryMutation,
  useAddCategoryMutation,
  useLazyGetCategoryByIdQuery,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useGetSubCategoryMutation,
  useAddSubCategoryMutation,
  useUpdateSubCategoryMutation,
  useLazyGetSubCategoryByIdQuery,
  useDeleteSubCategoryMutation,
  useLazyAllCategoryQuery,
  useLazyAllSubcategoriesQuery,
  useLazyGetChatListQuery,
  useLazyGetChatHistoryQuery,
} = mainApi;
